
import { ProcessAPI } from 'lecom-api';

import PostMessageEventHandler from "post_message/post_message_event_handler";
import FormEvents from "form/events/form_events";

const handleSetFieldsProperties = (data, formAPI) => {
	const dataEnsuredThatIsArray = Array.isArray(data) ? data : [data];
	dataEnsuredThatIsArray.forEach(it => handleSetFieldProperties(formAPI, it));
	formAPI.apply();
};

const handleSetFieldProperties = (formAPI, { gridId, fieldId, fieldProperties }) => {
	const field = getFieldAPI(formAPI, gridId, fieldId);
	field.set(fieldProperties)
};

const getFieldAPI = (formAPI, gridId, fieldId) => {
	return gridId
		? formAPI.fields(fieldId)
		: formAPI.fields(gridId).fields(fieldId);
};

PostMessageEventHandler.subscribe(FormEvents.SET_FIELD_PROPERTIES, (event, message) =>
handleSetFieldsProperties(message.data, ProcessAPI.currentProcess().form())
);
